import { PanelGroup, Panel } from '@dealroadshow/uikit-panel-group';
import SectionHeader from '@creditflowresearch/uilib/SectionHeader';
import SectionItemList from '@creditflowresearch/uilib/SectionItemList';
import { ISection } from '@creditflowresearch/uilib/Section';
import IconCollapse from '@creditflowresearch/uilib/Icon/IconCollapse';
import IconExpand from '@creditflowresearch/uilib/Icon/IconExpand';

import styles from './collapsibleSectionList.module.scss';

interface ICollapsibleSectionListProps {
  sections: ISection[],
  className?: string,
  defaultExpandedKeys?: string[],
}

const CollapsibleSectionList = ({
  sections,
  className,
  defaultExpandedKeys = [],
}: ICollapsibleSectionListProps) => (
  <PanelGroup
    dataTest="sectionCollapsible"
    defaultActiveKey={ defaultExpandedKeys }
    className={ className }
  >
    { sections.map((section) => (
      <Panel
        key={ section.id }
        id={ section.id }
        dataTest={ `section-${ section.id }` }
        className={ styles.panel }
        headerClass={ styles.panelHeader }
        contentClass={ styles.panelContent }
        arrowWrapperClass={ styles.arrow }
        header={ (
          <SectionHeader
            label={ section.sectionLabel }
            badge={ section.sectionBadge }
            badgeColor={ section.sectionColor }
            href={ section.sectionHref }
            isActive={ section.isActive }
          />
        ) }
        arrow={ <IconExpand /> }
        arrowActive={ <IconCollapse /> }
      >
        <SectionItemList items={ section.items } />
      </Panel>
    )) }
  </PanelGroup>
);

export default CollapsibleSectionList;
